/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { PaymentLinkPage } from 'src/scenes/PaymentLinkPage';
import { VersionPage } from 'src/scenes/VersionPage';

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        height: '100%',
    },
}));

export function App() {
    const classes = useStyles();

    const showVersionsPage = urlEndsWithVersions();
    if (showVersionsPage) {
        return (
            <main className={classes.layout}>
                <VersionPage />
            </main>
        );
    }

    return (
        <main className={classes.layout}>
            <PaymentLinkPage />
        </main>
    );
}

function urlEndsWithVersions() {
    return window.location.pathname.match(/\/version$/)?.[0];
}
